import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorService } from "../../../services/api/vendor.service";
import { VendorActions } from "../../actions/vendor.actions";
import { FailState } from "../../models/fail-state";
import { VendorState } from "../../models/vendor-state";

@Injectable()
export class VendorUpdateAgreementSigningStatusEffects {
	updateVendorAgreementSigningStatus = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.account.updateVendorAgreementSigningStatus),
			switchMap(() =>
				this.vendorService.checkVendorAgreementSigningStatus().pipe(
					map((vendorState: VendorState) => {
						vendorState.loading = false;
						return VendorActions.account.updateVendorAgreementSigningStatusSuccess(
							vendorState
						);
					}),
					catchError((error) =>
						of(
							VendorActions.account.updateVendorAgreementSigningStatusFail(
								new FailState(error)
							)
						)
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private vendorService: VendorService
	) {}
}
